<template>
  <div v-if="visible" class="row mb-3">
    <!-- Question -->

    <div class="col-12 px-0 border-bottom">
      <div class="row">
        <!-- Question Order -->
        <div
          v-if="showDisplayNumber"
          class="col-1 p-0 text-white d-flex justify-content-center"
        >
          <div
            class="question-section question-order text-center d-flex justify-content-center align-items-center font-weight-bold"
          >
            <span class="question-number">{{ item.displayNumber }}.</span>
          </div>
        </div>
        <!-- Question Description -->
        <div
          :class="{
            'flex-column justify-content-start align-items-start': resolution,
            'align-items-center': !resolution,
          }"
          class="col-8 col-sm-7 pl-0 d-flex"
        >
          <template v-if="resolution">
            <p class="mb-0 font-weight-bold">
              Firmas de los miembros del Comité de Programación y Ubicación
            </p>
            <p class="mb-0 font-weight-bold">
              Comentario:
            </p>
            <small>{{ question.comment }}</small>
          </template>
          <p v-else class="mb-0 question-description">
            <span class="question-title">{{ item.title }}</span>
            <span
              v-if="required && question.answer == null"
              class="has-error-label"
            >
              Favor de contestar Sí o No
            </span>
          </p>
        </div>
        <!-- Question Answer -->
        <AnswerBox
          :resolution="resolution"
          :answer="getAnswer(question)"
          :is-valid="question.isValid"
          :resolutions-list="item.resolvedControversyList"
          :parent-question="question.parentQuestion"
          :submitted="submitted"
          @changedAnswer="changeAnswer"
        />
      </div>
    </div>

    <!-- Question Form -->
    <div
      v-if="question.answer && !resolution && showDisplayNumber"
      class="col-12 px-0"
    >
      <div class="row">
        <!-- Question Description -->
        <div
          class="question-description-container p-4 d-flex align-items-center question-footer flex-column"
        >
          <div class="w-100 mt-n3">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <CustomTextArea
                v-model="question.comment"
                placeholder="Explique"
                :maxlength="300"
                class="question-textarea w-100"
                :error="errors[0]"
                custom-error-msg="Favor de entrar razones de la controversia"
                :disabled="submitted"
              />
            </ValidationProvider>
          </div>
          <div v-if="question.fields" class="field-group w-100 mb-3">
            <label v-if="question.serviceSectionDescription" class="w-100">
              {{ question.serviceSectionDescription }}
            </label>
            <div class="d-flex align-items-center justify-content-between">
              <div
                v-for="service in question.fields"
                :key="service.id"
                class="custom-control custom-checkbox custom-control-inline"
              >
                <input
                  :id="service.id"
                  v-model="service.selected"
                  type="checkbox"
                  class="custom-control-input"
                  :disabled="submitted"
                />
                <label class="custom-control-label font" :for="service.id">
                  {{ service.description }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import AnswerBox from './controversy/components/AnswerBox';
import { CustomTextArea } from '@/components/common';

export default {
  name: 'CustomFormQuestion',
  components: {
    AnswerBox,
    ValidationProvider,
    CustomTextArea,
  },
  props: {
    question: {
      type: Object,
      default: () => {},
      required: true,
    },
    showDisplayNumber: {
      type: Boolean,
      default: () => true,
    },
    resolution: {
      type: Boolean,
      default: () => false,
    },
    submitted: {
      type: Boolean,
      default: () => false,
    },
    visible: {
      type: Boolean,
      default: () => false,
    },
    required: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      item: this.question,
    };
  },
  mounted() {
    if (this.question.fields && this.question.fields.length > 0)
      this.question.fields.sort((a, b) =>
        a.description.localeCompare(b.description)
      );
  },
  methods: {
    changeAnswer(answer) {
      this.question.answer = answer.response;

      if (!answer) this.question.comment = '';

      if (this.question.parentQuestion === null) {
        this.$emit('updateParentQuestion', this.question.answer);
      }
    },
    getAnswer(question) {
      if (question.answer === null) {
        return {
          index: -1,
          value: null,
          response: null,
        };
      } else {
        return {
          index: question.answer ? 0 : 1,
          value: question.answer ? 'SI' : 'NO',
          response: question.answer ? true : false,
        };
      }
    },
  },
};
</script>

<style scope>
.question-textarea {
  border: none;
}
.question-textarea:read-only {
  background: #f2f2f2;
}
.question-textarea:focus {
  outline: none;
}
.question-description {
  font: 18px Lato;
}
.question-footer {
  background-color: #f4f6f3;
}
.question-section.question-order {
  background-color: #ff7058;
  color: white;
}
.question-section {
  width: 60px;
  min-height: 60px;
  border-radius: 5px 5px 0px 0px;
  font: 20px Lato;
}
.question-section.active {
  background-color: #2db782;
}
.question-section {
  background-color: #f2f2f2;
  color: #c9c9c9;
}
.question-answer {
  cursor: pointer;
}
.custom-control-label:focus {
  outline: none;
}
.custom-control-input:checked:disabled ~ .custom-control-label.font::before {
  /* color:#2db782; */
  background-color: #2db782;
  border-color: #2db782;
}
.custom-control-input:checked ~ .custom-control-label.font::before {
  /* color:#2db782; */
  background-color: #2db782;
  border-color: #2db782;
}

.question-description-container {
  width: 87%;
  margin-left: 110px;
}

.question-number {
  text-align: center;
  font: Bold 20px/24px Lato;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
}

.question-title {
  text-align: left;
  font: Regular 16px/18px Lato;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
}

.has-error-label {
  display: block;
  text-align: left;
  font: Medium 14px/18px Lato;
  letter-spacing: 0;
  color: #ff5b5c;
  opacity: 1;
}
</style>
